<template>
  <div>
    {{info}}
  </div>
</template>

<script>
  import brightsign from '@/services/brightsign'
  export default {
    name: 'Test2',
    components: {
    },
    data () {
      return {
        info: '',
        authData: 
        // {
        //   domain: 'dviewnetwork',
        //   username: 'creativo@descubregroup.com',
        //   password: 'k3LPw6t2',
        //   access_token: null,
        //   network: 'PRUEBAS'
        // }
        {
            domain: 'dviewnetwork',
            username: 'admin@dviewnetwork.com',
            password: 'r7W9YzBw',
            access_token: null,
            network: 'DESCUBREGROUP'
          },
      }
    },
    computed: {
    },
    mounted () {
      this.getData()
    },
    methods: {
      async getData() {
        const token = await brightsign.getTokens(this.authData)
        this.info = await brightsign.getDevice(this.authData, token, '')
      }
    }
  }
</script>

<style scoped>
  .main {
    padding: 15px;
  }
</style>
